<script>
    import PlayerDiv from './PlayerDiv.svelte';
    import PlayerModal from './PlayerModal.svelte';
    import NoProj from './NoProj.svelte';
    import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
	import { Swiper, SwiperSlide } from 'swiper/svelte/swiper-svelte.js';
	import GameCard from './GameCard.svelte';
    import 'swiper/swiper-bundle.min.css';
	// swiper core styles
	import 'swiper/swiper.min.css';
	// modules styles
	import 'swiper/modules/navigation/navigation.min.css';
	import 'swiper/modules/pagination/pagination.min.css';
    import { searchFilter, positionFilter, getTeams, filterByTeam, gameStrings } from './filter_utils.js';
	export let player_stats;
    export let games = [];
    export let premium_membership = true;
    export let placeholder_variances = {};
    let mobile = window.innerWidth < 768;
    function checkMobile() {
		if(window.innerWidth < 768) {
			mobile = true;
		} else {
			mobile = false;
		}
	}
	window.onresize = checkMobile;
    let playerSearchString = "";
    let selectedTeam = "all";
    let pos_filter = "all";
    let teams = getTeams(games);
    let position_filters = ["PG", "SG", "SF", "PF", "C"];
    let teamGameStrings = gameStrings(games);
    let sortableCols = {name:0, min:0, points:0, rebounds:0, assists:0, blocks:0, steals:0, turnovers:0, fp:0, dk_fp:0};
    let sortClasses = ["sort-asc", "", "sort-desc"];
    let modal_player;
    let modal_projection_id;
    function showPlayerModal(player) {
        modal_projection_id = player.stats.proj_id;
        modal_player = player;
        let myModal = new bootstrap.Modal(document.getElementById('player-modal'));
		myModal.show();
    }
    function sortByX(key, sortableCols, players, toggle=1){
		if(key == "val"){
			sortByValue(toggle);
			return;
		}
		if(sortableCols[key] == 1){
			sortableCols[key] = -1 * toggle;
		}
		else{
			sortableCols[key] = 1 * toggle;
		}
        //check if players has property stats
        if(key != "name" && players[0].stats){
            players.sort((a, b) => (a.stats[key] > b.stats[key]) ? -1 * sortableCols[key]: 1 * sortableCols[key]);
        }
        else{
            players.sort((a, b) => (a[key] > b[key]) ? -1 * sortableCols[key]: 1 * sortableCols[key]);
        }
        for(var prop in sortableCols){
			if(prop != key){
				sortableCols[prop] = 0;
			}
		}
        return {players:players, sortableCols:sortableCols};
	}
</script>
<style>
    .sorter{
		padding-right: 30px;
		position:relative;
	}
    .padding-r-30{
        padding-right: 30px;
    }
    .sticky-col {
        position: -webkit-sticky;
        position: sticky;
        left: 0px;
        background-color: #fff;
        z-index: 1;
    }
    .sticky-table-head{
        position: -webkit-sticky;
        position: sticky;
        top: 0px;
        background-color: #fff;
        z-index: 2;
    }
    .sticky-shadow-right{
        /*add webkit box shadow to fix safari bug*/
        -webkit-box-shadow: inset -1px 0px 0px 0px #ccc;
        box-shadow: inset -1px 0px 0px 0px #ccc;
    }
    .sticky-shadow-bottom{
        /*add webkit box shadow to fix safari bug*/
        -webkit-box-shadow: inset 0px -1px 0px 0px #ccc;
        box-shadow: inset 0px -1px 0px 0px #ccc;
    }
    .pointer{
		cursor:pointer;
	}
    .sorter.sort-asc:before{
		opacity: 1 !important;
	}
	.sorter.sort-desc:after{
		opacity: 1 !important;
	}
	.sorter:after,.sorter:before{
		position: absolute;
        bottom: 0em;
        display: block;
        opacity: .3;
		height:100%;
	}
	.sorter:after{
		right: .5em;
		content: "↓";
	}
	.sorter:before{
		right: 1em;
        content: "↑";
	}
</style>
{#if games.length > 0}
<PlayerModal placeholder_variances={placeholder_variances} player={modal_player} proj_id={modal_projection_id} premium_membership={premium_membership}></PlayerModal>
<div style="background-color:#e9ecef;" class="bg-gradient shadow border-top border-bottom py-2 mb-4">
	<h1 class="ps-2 display-6 lh-1">Games</h1>
	<Swiper
		modules={[Navigation, Pagination, Scrollbar, A11y]}
		spaceBetween={10}
		navigation="{!mobile}"
		pagination={{ clickable: true }}
		breakpoints={{
			320: {
				slidesPerView: 1,
				spaceBetween: 10
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 10
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 10
			},
			1280: {
				slidesPerView: 4,
				spaceBetween: 10
			},
			1920: {
				slidesPerView: 5,
				spaceBetween: 10
			}
		}}
	>
		{#each games as game}
		<SwiperSlide><GameCard home_team={game.home_team} away_team={game.away_team} game_time={game.game_time} lines={game.lines}></GameCard></SwiperSlide>
		{/each}
	</Swiper>
</div>
<div class="container-fluid">
    <div class="row">
        <div class="col-lg-4 pb-1 mt-auto">
            <label for="team-select">Filter By Team</label>
            <select bind:value={selectedTeam} on:change="{()=>{player_stats=player_stats}}" class="form-select form-select-lg" id="team-select">
                <option value="all">All</option>
                {#each teams as team}
                    <option value="{team.short_name}">{team.city_name} {team.mascot_name}</option>
                {/each}
            </select>
        </div>
        <div class="col-lg-4 pb-1 mt-auto">
            <div class="d-flex h-100 align-items-center btn-group" role="group" aria-label="Basic radio toggle button group">
            <input type="radio" bind:group={pos_filter} on:click={()=>{player_stats=player_stats;}} value="all" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off">
            <label class="w-100 btn btn-outline-primary" for="btnradio1">All</label>
            {#each position_filters as position, index}
            <input type="radio" bind:group={pos_filter} on:click={()=>{player_stats=player_stats;}} class="btn-check" name="btnradio" id="btnradio{index+2}" value="{position}" autocomplete="off">
            <label class="w-100 btn btn-outline-primary" for="btnradio{index+2}">{position}</label>
            {/each}
            </div>
        </div>
        <div class="col-lg-4 pb-1 mt-auto">
            <div class="input-group input-group-lg">
                <span class="input-group-text" id="inputGroup-sizing-lg">🔍</span>
                <input bind:value={playerSearchString} on:keyup={()=>{setTimeout(player_stats=player_stats,500)}} autocomplete="off" id="player-search" type="text" class="form-control" aria-label="Sizing example input" placeholder="Search for a Player..." aria-describedby="inputGroup-sizing-lg">
            </div>
        </div>
    </div>
    
    <div class="table-responsive modern-card bg-light m-2 pb-2" style="max-height: 75vh;">
        <table class="table">
            <thead class="sticky-table-head sticky-shadow-bottom pt-2">
                <tr class="ps-2">
                    <th on:click={()=>{let sortResult = sortByX("name", sortableCols, player_stats); player_stats = sortResult.players; sortableCols = sortResult.sortableCols;}} class="sticky-col sticky-shadow-right {sortClasses[sortableCols["name"]+1]} padding-r-30 sorter pointer">Name</th>
                    <th class="{sortClasses[sortableCols["min"]+1]} padding-r-30 text-center sorter pointer" on:click={()=>{let sortResult = sortByX("min", sortableCols, player_stats); player_stats = sortResult.players; sortableCols = sortResult.sortableCols;}}>Min</th>
                    <th class="{sortClasses[sortableCols["points"]+1]} padding-r-30 text-center  sorter pointer" on:click={()=>{let sortResult = sortByX("points", sortableCols, player_stats); player_stats = sortResult.players; sortableCols = sortResult.sortableCols;}}>Points</th>
                    <th class="{sortClasses[sortableCols["rebounds"]+1]}padding-r-30 text-center  sorter pointer" on:click={()=>{let sortResult = sortByX("rebounds", sortableCols, player_stats); player_stats = sortResult.players; sortableCols = sortResult.sortableCols;}}>Rebounds</th>
                    <th class="{sortClasses[sortableCols["assists"]+1]} padding-r-30 text-center sorter pointer" on:click={()=>{let sortResult = sortByX("assists", sortableCols, player_stats); player_stats = sortResult.players; sortableCols = sortResult.sortableCols;}}>Assists</th>
                    <th class="{sortClasses[sortableCols["blocks"]+1]} padding-r-30 text-center sorter pointer" on:click={()=>{let sortResult = sortByX("blocks", sortableCols, player_stats); player_stats = sortResult.players; sortableCols = sortResult.sortableCols;}}>Blocks</th>
                    <th class="{sortClasses[sortableCols["steals"]+1]} padding-r-30 text-center sorter pointer" on:click={()=>{let sortResult = sortByX("steals", sortableCols, player_stats); player_stats = sortResult.players; sortableCols = sortResult.sortableCols;}}>Steals</th>
                    <th class="{sortClasses[sortableCols["turnovers"]+1]} padding-r-30 text-center sorter pointer" on:click={()=>{let sortResult = sortByX("turnovers", sortableCols, player_stats); player_stats = sortResult.players; sortableCols = sortResult.sortableCols;}}>Turnovers</th>
                    <th class="{sortClasses[sortableCols["fp"]+1]} padding-r-30 sorter text-center pointer" on:click={()=>{let sortResult = sortByX("fp", sortableCols, player_stats); player_stats = sortResult.players; sortableCols = sortResult.sortableCols;}}>FD FP</th>
                    <th class="{sortClasses[sortableCols["dk_fp"]+1]} padding-r-30 sorter text-center pointer" on:click={()=>{let sortResult = sortByX("dk_fp", sortableCols, player_stats); player_stats = sortResult.players; sortableCols = sortResult.sortableCols;}}>DK FP</th></tr>
            </thead>
            <tbody class="border-top-0">
                {#each player_stats as ps}
                {#if positionFilter(ps, pos_filter) && searchFilter(ps, playerSearchString) && filterByTeam(ps.team, selectedTeam)}
                <tr class="ps-2">
                    <td class="pointer sticky-col sticky-shadow-right pb-0" on:click={()=>{showPlayerModal(ps)}}>
                        <PlayerDiv player_image={ps.img_thumb} player_positions={ps.positions} player_name={ps.name} detail_string={teamGameStrings[ps.team]} player_inj_tag={ps.injury_tag}/>
                    </td>
                    <td class="align-bottom padding-r-30 text-center">{ps.stats.min}</td>
                    <td class="align-bottom padding-r-30 text-center">{ps.stats.points}</td>
                    <td class="align-bottom padding-r-30 text-center">{ps.stats.rebounds}</td>
                    <td class="align-bottom padding-r-30 text-center">{ps.stats.assists}</td>
                    <td class="align-bottom padding-r-30 text-center">{ps.stats.blocks}</td>
                    <td class="align-bottom padding-r-30 text-center">{ps.stats.steals}</td>
                    <td class="align-bottom padding-r-30 text-center">{ps.stats.turnovers}</td>
                    <td class="align-bottom padding-r-30 text-center">{ps.stats.fp}</td>
                    <td class="align-bottom padding-r-30 text-center">{ps.stats.dk_fp}</td>
                </tr>
                {/if}
                {/each}
            </tbody>
        </table>
    </div>
</div>
{:else}
<NoProj league={"NBA"} logo_url={window.logo_url}></NoProj>
{/if}
